/** @jsx jsx */
import { jsx } from "theme-ui"
/* import React from 'react'; */
import Image from 'gatsby-image';


export default ({ posts }) => (
  <div sx={instaStyles.grid}>
    {posts.edges.map(
      (item, i) =>
        item.node.localImage && (
          <Image
            width='250'
            fluid={item.node.localImage.childImageSharp.fluid}
            key={i}
            alt={
              item.node.caption || 'Instagram Post'
            }
          />
        )
    )}
  </div>

)

const instaStyles = {
  grid:{
    gridTemplateColumns: 'repeat(auto-fit, minmax(15rem, 1fr))',
    gridtemplateRows: 'repeat(auto-fill, minmax(15rem, 1fr))',
    display: 'grid',
    justifyContent: 'center',
    alignContent: 'end',
    margin: '5% auto',
    gridGap: '0.3rem',
  },  
    img:{
      bg: "primary",
    },
}